import { createRouter, createWebHistory } from 'vue-router';
import { store } from '@/store/store';

// Route components are lazy-loaded so each view ships as its own chunk,
// loaded on demand instead of bundled into the initial app entrypoint.
const MyProfile = () => import('@/components/MyProfile.vue');
const TestPage = () => import('@/views/TestPage.vue');
const LoginPage = () => import('@/views/LoginPage.vue');
const DashboardPage = () => import('@/views/DashboardPage.vue');
const AllProducts = () => import('@/views/AllProducts.vue');
const UpdateProduct = () => import('@/components/UpdateProduct.vue');
const AddProduct = () => import('@/components/AddProduct.vue');
const ManageOrders = () => import('@/components/ManageOrders.vue');
const EditOrder = () => import('@/components/EditOrder.vue');
const ManageUsers = () => import('@/components/ManageUsers.vue');
const EditUser = () => import('@/components/EditUser.vue');
const ManageCategories = () => import('@/components/ManageCategories.vue');
const ManageRequests = () => import('@/components/ManageRequests.vue');
const HomepageBanners = () => import('@/components/HomepageBanners.vue');
const HomepageProductSections = () => import('@/components/HomepageProductSections.vue');
const ContactFormSubmissions = () => import('@/views/ContactFormSubmissions.vue');
const CouponAdmin = () => import('@/views/CouponAdmin.vue');
const BrandBanners = () => import('@/views/BrandBanners.vue');
const UpdateBrandBanner = () => import('@/components/UpdateBrandBanner.vue');

const routes = [
  { path: '/', component: LoginPage },
  { path: '/dashboard', component: DashboardPage, meta: { requiresAuth: true } },
  { path: '/profile', component: MyProfile, meta: { requiresAuth: true }  },
  { path: '/products', component: AllProducts, meta: { requiresAuth: true }  },
  {
    path: '/admin/products/edit/:id',
    name: 'UpdateProduct',
    component: UpdateProduct,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/products/add',
    name: 'AddProduct',
    component: AddProduct,
    props: true,
    meta: { requiresAuth: true }
  },
  { path: '/users', component: ManageUsers, meta: { requiresAuth: true }  },
  {
    path: '/users/update/:id',
    name: 'EditUser',
    component: EditUser,
    props: true,
    meta: { requiresAuth: true }
  },
  { path: '/orders', component: ManageOrders, meta: { requiresAuth: true }  },
  {
    path: '/orders/update/:id',
    name: 'EditOrder',
    component: EditOrder,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/categories',
    name: 'ManageCategories',
    component: ManageCategories,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/request',
    name: 'ManageRequests',
    component: ManageRequests,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/banners',
    name: 'HomepageBanners',
    component: HomepageBanners,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/homepage-sections',
    name: 'HomepageProductSections',
    component: HomepageProductSections,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/contact-form-submissions',
    name: 'ContactFormSubmissions',
    component: ContactFormSubmissions,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/coupons',
    name: 'CouponAdmin',
    component: CouponAdmin,
    meta: { requiresAuth: true }
  },
  {
    path: '/brand-banners',
    name: 'BrandBanners',
    component: BrandBanners,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/brand-banners/add',
    name: 'AddBrandBanner',
    component: UpdateBrandBanner,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/brand-banners/edit/:slug',
    name: 'UpdateBrandBanner',
    component: UpdateBrandBanner,
    props: true,
    meta: { requiresAuth: true }
  },
  { path: '/test', component: TestPage, meta: { requiresAuth: true } },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Navigation Guard for Auth
router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters.isLoggedIn
  if (to.meta.requiresAuth && !isLoggedIn) {
    next('/');
  } else {
    next();
  }
});

export default router;
